<template>
  <b-table :fields="fields" :items="sortedJobs" primary-key="job_id" stripped hover ref="jobTable">
    <template v-slot:cell(picture)="data">
      <span v-if="sortable" class="icon icon--move-vertical"></span>
      <model-preview
          :icon-img="data.item.picture_preview"
          :preview-img="data.item.picture"
          :video-link="data.item.gif_image"
          @openTimelaps="handleOpenTimelaps(data.item.job_id)">
      </model-preview>
      <job-status :job-status-id="data.item.job_status_id"></job-status>
    </template>
    <template v-slot:cell(filename)="data">
      <blurred-random-word length="20" v-if="data.item.hide_job === 't'" :tooltip="$t('printers.job.denyFilename')"></blurred-random-word>
      <span v-else>
        {{fileNameCut(data.item.filename, 25, false)}}
      </span>
    </template>
    <template v-slot:cell(date_author)="data">
      <date-time-text class="edit-time" :date="data.item.added_to_queue"></date-time-text>
      <span class="text--muted"> {{$t('history.by')}} </span>
      <blurred-random-word length="20" v-if="data.item.hide_job === 't'" :tooltip="$t('printers.job.denyAuthor')"></blurred-random-word>
      <span v-else-if="!isMyEmail(data.item.email)">{{data.item.email}}</span>
      <span v-else>{{$t('history.ownEmail')}}</span>
    </template>
    <template v-slot:cell(cost)="data">
      <job-cost :cost="data.item.cost"></job-cost>
    </template>
    <template v-slot:cell(filament)="data">
      <job-filament :filament="data.item.filament"></job-filament>
    </template>
    <template v-slot:cell(printTime)="data">
      <print-time :estimated-time="data.item.time_to_print" :print-time="data.item.print_time_real" :object-id="data.item.job_id"></print-time>
    </template>
    <template v-slot:cell(buttons)="data">
      <job-action-buttons :ref="'actionButtons' + data.item.job_id" :job="data.item" :printer="printer"></job-action-buttons>
    </template>
  </b-table>
</template>

<script>
  import Sortable from "sortablejs";

  import JobStatus from "./JobStatus";
  import JobFilament from "./JobFilament";
  import JobCost from "./JobCost";
  import JobActionButtons from "./JobActionButtons";

  import BlurredRandomWord from "@/components/BlurredRandomWord";

  import RandomWordMixin from "@/mixins/randomWord";
  import FileMixin from '@/mixins/file';
  import UserMixin from '@/mixins/user';
  import ModelPreview from "../../ModelPreview";
  import DateTimeText from "../../DateTimeText";
  import PrintTime from "../../PrintTime";

  export default {
    name: 'job-table',
    props: ['jobs', 'printer', 'sortable'],
    components: {
      PrintTime,
      DateTimeText,
      ModelPreview,
      JobStatus,
      JobFilament,
      JobCost,
      JobActionButtons,
      BlurredRandomWord
    },
    mixins: [RandomWordMixin, FileMixin, UserMixin],
    data() {
      return {
        fields: [
          {key: "picture", class: 'img'},
          {key: "filename", class: 'name'},
          {key: "printTime", class: 'print-time'},
          {key: "date_author", class: 'date'},
          {key: "cost", class: 'cost'},
          {key: "filament", class: 'fill'},
          {key: "buttons", class: 'action1'}
        ],
        sortableInstance: null
      }
    },
    computed: {
      sortedJobs() {
        let jobs = this.jobs;
        jobs.sort((a, b) => {
          let aIndex = a.job_status_id <= 35 && a.job_status_id != 11 ? 0 : a.job_status_id;
          if (aIndex == 11) {
            aIndex = 1;
          } else if (aIndex==77) {
            aIndex = 2;
          }
          let bIndex = b.job_status_id <= 35 && b.job_status_id != 11 ? 0 : b.job_status_id;
          if (bIndex == 11) {
            bIndex = 1;
          } else if (bIndex==77) {
            bIndex = 2;
          }
          if (aIndex < bIndex) {
            return -1;
          } else if (aIndex > bIndex) {
            return 1
          }

          return 0;
        });

        return jobs;
      },
    },
    methods: {
      handleOpenTimelaps(job_id) {
        this.$refs['actionButtons' + job_id].handleOpenTimelaps();
      }
    },
    watch: {
      sortable: function(val) {
        console.log(this.sortableInstance);
        if (val) {
          this.sortableInstance = Sortable.create(this.$refs['jobTable'].$el.querySelector("tbody"), {
            onEnd(e) {
              console.log(e);
            }
          })
        } else {
          this.sortableInstance.destroy();
        }
      }
    }
  }
</script>
